import React from "react";
import YesNoColumn from "./YesNoColumn";

const PartnerEnabledColumn = ({active}) => <YesNoColumn active={active}/>

export default PartnerEnabledColumn;
